import type { OnboardingStatus } from '@cdw-ae/common-data';
import type { ChipTone } from '../chip-tone';

/**
 * Display helpers for the customers table `onboarding_status` latch
 * (EDUS-2726). Null only for rows created before the column's migration ran
 * (the migration backfills, so effectively transient).
 */
const ONBOARDING_STATUS_LABELS = {
  // Login routes the customer's SAs into the app.
  initialized: 'Onboarded',
  // Login routes the customer's SAs into the setup wizard.
  uninitialized: 'Setup pending',
} satisfies Record<OnboardingStatus, string>;

/** Chip tones, matching the DWD chip palette. */
const ONBOARDING_STATUS_TONES = {
  initialized: 'ok',
  uninitialized: 'warn',
} satisfies Record<OnboardingStatus, ChipTone>;

export function onboardingStatusLabel(status: OnboardingStatus | null): string {
  return status ? ONBOARDING_STATUS_LABELS[status] : 'Unknown';
}

export function onboardingStatusTone(status: OnboardingStatus | null): ChipTone {
  return status ? ONBOARDING_STATUS_TONES[status] : 'neutral';
}
